"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.journalModificationToPreview = exports.mergeJournalModification = exports.toJournalModification = exports.JournalKeys = exports.DetailKeys = exports.SearchIdPrefixEnabledVoucherKeys = exports.BilledFromEnabledVoucherKeys = exports.BankKeys = exports.EnumKeys = exports.VoucherKeys = void 0;
var lodash_1 = require("lodash");
var util_1 = require("remota-common/util");
exports.VoucherKeys = {
    AMOUNT: "amount",
    AMOUNT_TAX_EXCLUDED: "amountTaxExcluded",
    ISSUER: "issuer",
    ISSUER_TELS: "issuerTels",
    BANKS: "banks",
    DETAIL_LINES: "detailLines",
    JOURNAL_MODIFICATION: "journalModification",
    JOURNAL_PREVIEW: "journalPreview",
    DETAIL_HEADER_OTHER: "detailHeader.other",
    PAID_CURRENCY: "paidCurrency",
    REGISTRATION_NUMBERS: "registrationNumbers",
    DATE: "date",
    VOUCHER: "voucher",
    DETAIL_TAX_TYPE: "detailTaxType",
};
exports.EnumKeys = {
    BILLED_FROM: "billedFrom",
    PAID_CURRENCY: "paidCurrency",
    DETAIL_TAX_TYPE: "detailTaxType",
    SEARCH_ID: "searchId",
};
exports.BankKeys = {
    NAME: "name",
    ACCOUNT_TYPE: "accountType",
    ACCOUNT_NUMBER: "accountNumber",
    SWIFT_CODE: "swiftCode",
    IBAN_CODE: "ibanCode",
    CNAPS_CODE: "cnapsCode",
    JOURNAL_MODIFICATION_ACCOUNT_NAME: "accountName",
};
exports.BilledFromEnabledVoucherKeys = [
    exports.EnumKeys.BILLED_FROM,
    exports.EnumKeys.PAID_CURRENCY,
    "banks[*].".concat(exports.BankKeys.SWIFT_CODE),
    "banks[*].".concat(exports.BankKeys.CNAPS_CODE),
    "banks[*].".concat(exports.BankKeys.IBAN_CODE),
];
exports.SearchIdPrefixEnabledVoucherKeys = [exports.EnumKeys.SEARCH_ID];
exports.DetailKeys = {
    OTHER: "other",
};
exports.JournalKeys = {
    DESCRIPTION: "description",
    UNIT_PRICE: "unitPrice",
    QUANTITY: "quantity",
    SUB_TOTAL: "subTotal",
    TAX: "tax",
    ACCOUNTING_TYPE: "accountingType",
    ACCOUNTING_TYPE_HEADER: "accountingTypeHeader",
    DETAIL_INDEXES: "detailIndexes",
};
var toJournalModification = function (parsedJson, shouldRegenerate) {
    var _a;
    var _b;
    // ハイパーペーストなどで、すでに仕訳修正の値が入っている場合は、そちらを優先する。
    var jms = (_b = (0, util_1.getVoucherValue)(parsedJson, exports.VoucherKeys.JOURNAL_MODIFICATION)) !== null && _b !== void 0 ? _b : [];
    var detailLines = (0, util_1.getVoucherValue)(parsedJson, exports.VoucherKeys.DETAIL_LINES);
    // If there are detail lines, use them as the base for the journal modification.
    // If there are no detail lines, use the issuer and amount as the base for the journal modification.
    if (detailLines && Array.isArray(detailLines) && detailLines.length > 0) {
        if (!shouldRegenerate && jms.length) {
            return jms;
        }
        return (0, lodash_1.range)(Math.max(detailLines.length, jms.length)).map(function (index) {
            var _a;
            var _b, _c;
            var dl = (_b = detailLines[index]) !== null && _b !== void 0 ? _b : {};
            var jm = (_c = jms[index]) !== null && _c !== void 0 ? _c : {};
            if (shouldRegenerate) {
                var regenerateKeys = [
                    exports.JournalKeys.DESCRIPTION,
                    exports.JournalKeys.SUB_TOTAL,
                    exports.JournalKeys.UNIT_PRICE,
                    exports.JournalKeys.QUANTITY,
                ];
                regenerateKeys.forEach(function (key) {
                    jm[key] = dl[key] || "";
                });
            }
            return __assign(__assign(__assign({}, dl), jm), (_a = {}, _a[exports.JournalKeys.DETAIL_INDEXES] = [index], _a));
        });
    }
    else {
        var detailTaxType = (0, util_1.getVoucherValue)(parsedJson, exports.VoucherKeys.DETAIL_TAX_TYPE);
        var description = (0, util_1.getVoucherValue)(parsedJson, exports.VoucherKeys.ISSUER);
        var amount = (0, util_1.getVoucherValue)(parsedJson, detailTaxType === "inclusive" ? exports.VoucherKeys.AMOUNT : exports.VoucherKeys.AMOUNT_TAX_EXCLUDED);
        var first_1 = (_a = {
                description: description,
                quantity: 1,
                unitPrice: amount
            },
            _a[exports.JournalKeys.SUB_TOTAL] = amount,
            _a[exports.JournalKeys.DETAIL_INDEXES] = [-1],
            _a);
        return (0, lodash_1.range)(Math.max(1, jms.length)).map(function (index) {
            var _a;
            var jm = (_a = jms[index]) !== null && _a !== void 0 ? _a : {};
            return index === 0 ? __assign(__assign({}, first_1), jm) : jm;
        });
    }
};
exports.toJournalModification = toJournalModification;
var mergeJournalModification = function (origin, update) {
    return (0, lodash_1.range)(0, Math.max((origin === null || origin === void 0 ? void 0 : origin.length) || 0, (update === null || update === void 0 ? void 0 : update.length) || 0)).map(function (_, i) {
        var _a;
        return (__assign(__assign(__assign({}, (0, util_1.toParsedJson)((_a = {},
            _a[exports.JournalKeys.DETAIL_INDEXES] = [i],
            _a))), origin === null || origin === void 0 ? void 0 : origin[i]), update === null || update === void 0 ? void 0 : update[i]));
    });
};
exports.mergeJournalModification = mergeJournalModification;
var journalModificationToPreview = function (lines) {
    return Object.values((0, lodash_1.groupBy)(lines, function (line) { var _a, _b; return ((_a = line === null || line === void 0 ? void 0 : line.accountingType) === null || _a === void 0 ? void 0 : _a.id) || ((_b = line === null || line === void 0 ? void 0 : line.accountingTypeHeader) === null || _b === void 0 ? void 0 : _b.id) || ""; })).map(function (lines) {
        return lines.slice(1).reduce(function (prev, line) { return merge(prev, line); }, lines[0]);
    });
};
exports.journalModificationToPreview = journalModificationToPreview;
var toNumber = function (value) {
    var num = Number(value);
    return isNaN(num) ? 0 : num;
};
var merge = function (line1, line2) {
    if (line1 === undefined)
        return __assign({}, line2);
    if (line2 === undefined)
        return __assign({}, line1);
    return Object.keys(line1).reduce(function (prev, key) {
        var _a, _b;
        if (key === exports.JournalKeys.SUB_TOTAL || key === exports.JournalKeys.TAX) {
            return __assign(__assign({}, prev), (_a = {}, _a[key] = toNumber(line1[key]) + toNumber(line2[key]), _a));
        }
        else if (key === exports.JournalKeys.DETAIL_INDEXES) {
            return __assign(__assign({}, prev), { detailIndexes: __spreadArray(__spreadArray([], __read((line1.detailIndexes || [])), false), __read((line2.detailIndexes || [])), false) });
        }
        else if ((0, lodash_1.isEqual)(line1[key], line2[key])) {
            return prev;
        }
        else {
            return __assign(__assign({}, prev), (_b = {}, _b[key] = "***", _b));
        }
    }, line1);
};
